var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6539"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.1478 20.9665C28.3092 20.9665 29.2507 19.9965 29.2507 18.7999C29.2507 17.6033 28.3092 16.6333 27.1478 16.6333C25.9864 16.6333 25.0449 17.6033 25.0449 18.7999C25.0449 19.9965 25.9864 20.9665 27.1478 20.9665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.224 20.9665C19.3854 20.9665 20.3269 19.9965 20.3269 18.7999C20.3269 17.6033 19.3854 16.6333 18.224 16.6333C17.0626 16.6333 16.1211 17.6033 16.1211 18.7999C16.1211 19.9965 17.0626 20.9665 18.224 20.9665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.3021 20.9665C10.4635 20.9665 11.405 19.9965 11.405 18.7999C11.405 17.6033 10.4635 16.6333 9.3021 16.6333C8.14071 16.6333 7.19922 17.6033 7.19922 18.7999C7.19922 19.9965 8.14071 20.9665 9.3021 20.9665Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.4ad3180a581f6a8a020dda1be9ca4dde.svg";
export { ForwardRef as ReactComponent };